/**
 * @fileoverview GET handler for the "/:app_group_id/campaign/:campaign_id/message/:message_variation_id" endpoint
 */
import type { MessageType } from "@lib/campaignMessageTypeConstants";
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { appGroupIdCampaignCampaignIdMessagesMessageVariationId } from "./constants";
import type { MessageResult } from "./types";

export const getCampaignMessageVariation = reactQueryFetcherAdapter(
  appGroupIdCampaignCampaignIdMessagesMessageVariationId,
  (
    signal: AbortSignal,
    appGroupId: string,
    campaignId: string,
    messageVariationId: string
  ): Promise<MessageResult<MessageType, unknown>> => {
    return fetch(`/${appGroupId}/campaign/${campaignId}/message/${messageVariationId}`, "GET", {}, { signal });
  }
);
